module.exports = __webpack_public_path__ + "img/0.c5934079.png";